<template>
    <div>
        <page-title :title="article.name+' | ' +article.sku"></page-title>

        <form-section @submitted="updatePassword">
            <template #title>
                {{ $t('articles.editTitle') }}
            </template>

            <template #description>
                {{ $t('articles.editDescription') }}
            </template>

            <template #form>
                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="stock_overwrite" :value="$t('articles.stockOverwrite')"/>
                    <jet-input id="stock_overwrite" type="number" class="mt-1 block w-full"
                               v-model="form.stock_overwrite"
                               ref="stock_overwrite"/>
                    <jet-input-error :message="form.errors.stock_overwrite" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="protected" :value="$t('articles.protected')"/>
                    <checkbox id="protected"
                              :value="$t('articles.protected')"
                              v-model:checked="form.protected"></checkbox>
                </div>
            </template>

            <template #actions>
                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ $t('actions.save') }}
                </primary-button>
            </template>
        </form-section>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import PageTitle from "../../Shared/Components/PageTitle";
import FormSection from "../../Jetstream/FormSection";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import PrimaryButton from "../../Jetstream/PrimaryButton";
import Checkbox from "../../Jetstream/Checkbox";
import {useForm} from "@inertiajs/vue3";

export default {
    props: ['article'],
    layout: AppLayout,
    components: {
        PageTitle,
        FormSection,
        JetLabel,
        JetInput,
        JetInputError,
        PrimaryButton,
        Checkbox
    },
    data() {
        return {
            form: useForm({
                stock_overwrite: this.article.stock_overwrite,
                protected: this.article.protected
            })
        }
    },

    methods: {
        updatePassword() {
            this.form.put(this.route('articles.update', this.article.id), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "main",
                    title: 'actions.success',
                    text: 'articles.updated'
                }, 2000)
            })
        },
    },
}
</script>

<style scoped>

</style>
